import { Component, ViewEncapsulation, OnInit, ElementRef, ViewChild, Input, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { CellRange, CellType, FlexGrid } from '@grapecity/wijmo.grid';

import { FileUploadService, FileAccept } from '../../../commons/kymw02/file-upload/file-upload.service';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { PlessViewUtilsSub } from '../../kymw00/pless-view-utils-sub.service';
import { PlessAlert } from '../../../shared/pless-alert/pless-alert.component';

import { KYMW00Model } from '../../kymw00/kymw00.model';

import { KYMW1900Component } from '../../../kymw/kymw19/kymw1900/kymw1900.component';
import { KYMW1900InputModel } from '../../../kymw/kymw19/kymw1900/vo/kymw1900-input.model';
import { KYMW1900OutputModel } from '../../../kymw/kymw19/kymw1900/vo/kymw1900-output.model';
import { KYMW1901Component } from '../../../kymw/kymw19/kymw1901/kymw1901.component';
import { KYMW1901InputModel } from '../../../kymw/kymw19/kymw1901/vo/kymw1901-input.model';
import { NvalInputModel } from './vo/nval-input.model';

import { KYMW0A00Model } from './kymw0a00.model';
import { KYMW0A00InputModel } from './vo/kymw0a00-input.model';
import { SelectPublishVoiceModel } from './vo/select-publish-voice-model';
import { GetMembersVoiceSearchListService } from './api-services/get-members-voice-search-list.service';
import { GetMembersVoicePcodeListService } from './api-services/get-members-voice-pcode-list.service';
import { GetPcodeList0AService } from './api-services/get-pcode-list-0a.service';
import { GetMembersVoiceDataService } from './api-services/get-members-voice-data.service';
import { UpdateMembersVoiceDataService } from './api-services/update-members-voice-data.Service';
import { GetPublishVoiceHistory0AService } from './api-services/get-publish-voice-history-0a.service';
import { RegistPublishVoiceDataService } from './api-services/regist-publish-voice-data.service';
import { GetPublishVoiceDataService } from './api-services/get-publish-voice-data.service';
import { CheckNgWords0AService } from './api-services/check-ng-words-0a.service';
import { UploadMembersVoiceDataService } from './api-services/upload-members-voice-data.service';
import { PublishVoiceDataModel } from './vo/publish-voice-data.model';
import { KYMW0A00OutputModel } from './vo/kymw0a00-output.model';
import { MembersVoiceSearchModel } from './vo/members-voice-search.model';
import { MembersVoiceInputDataModel } from './vo/members-voice-input-data.model';
import { DataGridUtil } from '../../kymw00/data-grid-util';
import { KYMW0D00Component } from '../../kymw0d/kymw0d00/kymw0d00.component';
import { NotNullTextInputComponent } from '../../kymw02/not-null-text-input/not-null-text-input.component';
import { RadioLabelComponent } from '../../kymw02/radio-label/radio-label.component';
import { NotNullTextAreaComponent } from '../../kymw02/not-null-text-area/not-null-text-area.component';

import { FunctionMenuService } from 'src/app/commons/kymw02/function-menu/function-menu.service';
import { FMenu } from 'src/app/commons/kymw02/function-menu/fmenu';

namespace STYLE_VISIBILITY {
  export const HIDDEN = 'hidden';
  export const SHOW = '';
}

/**
 * 組合員の声管理画面を管理するクラス
 *
 * @export KYMW0A00Component
 * @class KYMW0A00Component
 */
@Component({
  selector: 'app-kymw0a00',
  templateUrl: 'kymw0a00.component.html',
  styleUrls: ['kymw0a00.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW0A00Component extends PlessViewHelperSub implements OnInit, AfterViewInit {

  @Input() parentModel: KYMW0A00Model = null;

  @ViewChild('dtg_MembersVoiceList', { static: false }) dtg_MembersVoiceList: FlexGrid;
  @ViewChild('cmb_PcodeList', { static: false }) cmb_PcodeList: ElementRef;
  @ViewChild('btn_Back', { static: false }) btn_Back: ElementRef;
  @ViewChild('btn_Next', { static: false }) btn_Next: ElementRef;
  @ViewChild('txti_CorrectMemberName', { static: false }) txti_CorrectMemberName: NotNullTextInputComponent;
  @ViewChild('txti_CorrectAnonymous', { static: false }) txti_CorrectAnonymous: NotNullTextInputComponent;
  @ViewChild('rdbg_Coop', { static: false }) rdbg_Coop: RadioLabelComponent;
  @ViewChild('rdbg_Center', { static: false }) rdbg_Center: RadioLabelComponent;
  @ViewChild('txti_CenterName', { static: false }) txti_CenterName: NotNullTextInputComponent;
  @ViewChild('txta_InquiryContents', { static: false }) txta_InquiryContents: NotNullTextAreaComponent;
  @ViewChild('btn_Search', { static: false }) btn_Search: ElementRef;
  @ViewChild('btn_Update', { static: false }) btn_Update: ElementRef;
  @ViewChild('btn_Select', { static: false }) btn_Select: ElementRef;
  @ViewChild('btn_End', { static: false }) btn_End: ElementRef;

  /**
   * 選定済一覧 項目名
   * DataGridの列名とテーブル物理名を紐付ける連想配列Object
   */
  private selectedListField = new Map([
    ['ReceiptDate', 'RECEIPT_DATE'],
    ['CoopName', 'COOP_NAME'],
    ['MemberName', 'CORRECT_MEMBER_NAME'],
    ['Anonymous', 'CORRECT_ANONYMOUS'],
    ['ClassName', 'CLASS_NAME'],
    ['Subject', 'SUBJECT'],
    ['PublishCoop1', 'PUBLISH_COOP1'],
    ['PublishCoop2', 'PUBLISH_COOP2'],
    ['PublishCoop3', 'PUBLISH_COOP3'],
    ['PublishCoop4', 'PUBLISH_COOP4'],
    ['PublishCoop5', 'PUBLISH_COOP5'],
    ['PublishCoop6', 'PUBLISH_COOP6'],
    ['PublishCoop7', 'PUBLISH_COOP7'],
    ['PublishCoop8', 'PUBLISH_COOP8'],
    ['PublishCoop9', 'PUBLISH_COOP9'],
    ['InquiryContents', 'CORRECT_INQUIRY_CONTENTS'],
    ['PublishTypeName', 'PUBLISH_TYPE_NAME'],
    ['Pcode', 'PCODE'],
    ['CenterName', 'CENTER_NAME'],
    ['ReceiptNum', 'RECEIPT_NUM'],
  ]);

  public _initFlag: boolean = <boolean>true;
  public _initFlagGetPCodeList: boolean = <boolean>true;
  public _initFlagGetMembersVoiceData: boolean = <boolean>true;
  public _initFlagSetMembersVoiceList: boolean = <boolean>true;
  public _initFlagCheckNgWords: boolean = <boolean>true;

  // ファイルリファレンス。
  private fileRef: File[];

  /**
    * 権限「1」は閲覧モード「２」フルコントロール
    */
  public kymw19funcPermission: string = <string>'2';
  public kymw09funcPermission: string = <string>'2';
  public kymw14funcPermission: string = <string>'2';
  public kymw30funcPermission: string = <string>'2';
  public kymw32funcPermission: string = <string>'2';

  /** 検索実行フラグ */
  private searchFlg: boolean = <boolean>false;

  /** 元の画面への連携用 */
  public setKYMW0A00Parameter: Function;

  /**
   * 画面受渡情報
   * 画面呼び出し時に受け渡されるオブジェクト
   */
  public inputVO: KYMW0A00InputModel = null;

  /**
   * 組合員の声検索退避用VO
   */
  public kYMW1900OutputVO: KYMW1900OutputModel = new KYMW1900OutputModel();

  public kymw0A00Model: KYMW0A00Model = new KYMW0A00Model();

  /**
   * 組合員の声管理検索用VO
   */
  private membersVoiceSearchVO: MembersVoiceSearchModel;

  btnBackEnabled= false;
  btnNextEnabled = false;
  @Input() dispDialog: boolean = false;

  /**
   *Creates an instance of KYMW0A00Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW0A00Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
    private getMembersVoiceSearchListService: GetMembersVoiceSearchListService,
    private getMembersVoicePcodeListService: GetMembersVoicePcodeListService,
    private getMembersVoiceDataService: GetMembersVoiceDataService,
    private getPcodeList0AService: GetPcodeList0AService,
    private getPublishVoiceHistory0A: GetPublishVoiceHistory0AService,
    private updateMembersVoiceDataService: UpdateMembersVoiceDataService,
    private registPublishVoiceDataService: RegistPublishVoiceDataService,
    private getPublishVoiceDataService: GetPublishVoiceDataService,
    private checkNgWords0AService: CheckNgWords0AService,
    private uploadMembersVoiceDataService: UploadMembersVoiceDataService,
    private fileUploadService: FileUploadService,
    private fmenuService: FunctionMenuService,
    private changeDetector: ChangeDetectorRef
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof KYMW0A00Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW0A00';

    this.kymw0A00Model.kymw0A00Component = this;

    // 権限取得
    this.kymw19funcPermission = this.getFuncPermission('KYMW0A00');
    this.kymw09funcPermission = this.getFuncPermission('KYMW0900');
    this.kymw14funcPermission = this.getFuncPermission('KYMW1400');
    this.kymw30funcPermission = this.getFuncPermission('KYMW3000');
    this.kymw32funcPermission = this.getFuncPermission('KYMW3200');
  }

  ngAfterViewInit(): void {
    this.plessEnabledSetting();
    // テキスト背景色を強制的に『必須』にするための処理
    this.txti_CorrectAnonymous.textChanged();
    this.dtg_MembersVoiceList.itemsSourceChanged.addHandler(() => {
      this.dtg_MembersVoiceList.select(-1, -1);
    });
    this.changeDetector.detectChanges();
  }

  /**
   * ngOnInit内で設定するplessEnabledの処理を記述するメソッド
   *
   * @memberof KYMW0A00Component
   */
  public plessEnabledSetting() {
    // メニュー初期設定
    if (!this.dispDialog) {
      this.initMenuBar();
    }

    // 「前へ」ボタン「次へ」ボタンを非活性にする
    this.btnBackEnabled = false;
    this.btnNextEnabled = false;

    this._initFlag = true;
    this._initFlagGetMembersVoiceData = true;
    this._initFlagSetMembersVoiceList = true;
    this._initFlagGetPCodeList = true;
    this._initFlagCheckNgWords = true;

    // 呼出し元画面により、初期表示処理を分岐し処理する
    if (this.inputVO == null || this.inputVO.formId === 'KYMW1002') {
      // 『トップ』画面から呼出しの場合
      if (this.kymw19funcPermission === '1') {
        this.kymw0A00Model.btnUpdateVisible = STYLE_VISIBILITY.HIDDEN;
      } else {
        this.kymw0A00Model.btnUpdateVisible = STYLE_VISIBILITY.SHOW;
      }
      // 画面項目の制御
      this.kymw0A00Model.title = '組合員の声管理';
      this.kymw0A00Model.lblPcodeListLblVisible = STYLE_VISIBILITY.HIDDEN;
      this.kymw0A00Model.cmbPcodeListVisible = STYLE_VISIBILITY.HIDDEN;
      this.kymw0A00Model.lblGuideGoodsNameLblVisible = STYLE_VISIBILITY.HIDDEN;
      this.kymw0A00Model.lblGuideGoodsNameVisible = STYLE_VISIBILITY.HIDDEN;
      this.kymw0A00Model.lblGuideStandardNameLblVisible = STYLE_VISIBILITY.HIDDEN;
      this.kymw0A00Model.lblGuideStandardNameVisible = STYLE_VISIBILITY.HIDDEN;
      this.kymw0A00Model.btnSelectVisible = STYLE_VISIBILITY.HIDDEN;
      this.plessEnabled(this.btn_Update, false);
      this.btnBackEnabled = false;
      this.btnNextEnabled = false;
      this.enabledInputField(false);
      this.inputComponentEnable(false);
      this._initFlag = false;
      this._initFlagGetMembersVoiceData = false;
      this._initFlagSetMembersVoiceList = false;
      this._initFlagGetPCodeList = false;
      this._initFlagCheckNgWords = false;

      this.btn_Search.nativeElement.focus();

    } else if (this.inputVO.formId === 'KYMW0900') {
      // 『商品企画メンテナンス』画面から呼出しの場合
      this.InitCommonLogic('01');

      this.cmb_PcodeList.nativeElement.focus();

    } else if (this.inputVO.formId === 'KYMW1400') {
      // 『コマ割』画面から呼出しの場合

      // 画面項目の制御
      this.kymw0A00Model.title = '組合員の声選択';
      this.kymw0A00Model.btnUpdateVisible = STYLE_VISIBILITY.HIDDEN;
      this.inputComponentEnable(true);
      this.btnBackEnabled = false;
      this.btnNextEnabled = false;

      if (this.inputVO.editLockInfo === '1') {
        // ロック状態の場合
        this.plessEnabled(this.btn_Select, false);
        this.inputComponentEnable(false);
      }

      // 選択Ｐコード情報を取得する為、要求をサーバに送信する
      this.getPcodeList0AService.execute(this.kymw0A00Model, this.inputVO.pcodeList);

      // 組合員の声一覧情報を取得する為、要求をサーバに送信する
      this.membersVoiceSearchVO = new MembersVoiceSearchModel();
      this.membersVoiceSearchVO.setPcode = this.inputVO.pcodeList;
      this.membersVoiceSearchVO.setCoopCode = this.inputVO.coopCode;
      this.membersVoiceSearchVO.setOrderCode = this.inputVO.orderCode;
      this.membersVoiceSearchVO.orderGoodsFlg = this.inputVO.orderGoodsFlgKoma2;
      this.membersVoiceSearchVO.formId = this.inputVO.formId;
      // 注文商品区分他レイアウト情報取得
      this.membersVoiceSearchVO.orderGoodsFlgKoma = this.inputVO.orderGoodsFlgKoma;
      if (!PlessViewUtilsSub.isEmptyArray(this.inputVO.NvalInputList)) {
        // いつでも注文商品・いつ注W掲載商品の場合、コマ割り画面から取得したリストをvoに設定
        this.membersVoiceSearchVO.nvalInputList = this.inputVO.NvalInputList;
      } else {
        // 通常注文商品の場合、Ｐコードリスト数分空を設定
        for (let i = Number(0); i < this.inputVO.pcodeList.length; i++) {
          const nvalInput: NvalInputModel = new NvalInputModel();
          this.membersVoiceSearchVO.nvalInputList.push(nvalInput);
        }
      }

      this.membersVoiceSearchVO.initFlg = 1;                                    // 検索結果０件の場合エラーメッセージを表示しない。

      this.getMembersVoicePcodeListService.execute(this.kymw0A00Model, this.membersVoiceSearchVO, () => {
        this.eventGetMembersVoiceListFirstCloseSuccess();
      });

    } else if (this.inputVO.formId === 'KYMW3001') {
      // 『1物N価商品企画メンテナンス』画面から呼出しの場合
      this.InitCommonLogic('02');
    } else if (this.inputVO.formId === 'KYMW3201') {
      // 『1物N価商品Ｗ掲載メンテナンス』画面から呼出しの場合
      this.InitCommonLogic('03');
    }
  }

  private InitCommonLogic(orderGoodsFlg: string) {
    // 画面項目の制御
    this.kymw0A00Model.title = '組合員の声選択';
    this.kymw0A00Model.btnUpdateVisible = STYLE_VISIBILITY.HIDDEN;
    this.inputComponentEnable(true);
    this.btnBackEnabled = false;
    this.btnNextEnabled = false;
    this.plessEnabled(this.cmb_PcodeList, false);

    // 選択Ｐコード情報を取得する為、要求をサーバに送信する
    this.getPcodeList0AService.execute(this.kymw0A00Model, this.inputVO.pcodeList);

    // 組合員の声情報の取得
    if (!PlessViewUtilsSub.isEmpty(this.inputVO.receiptNum)) {
      // 「受付番号」がセットされている場合

      // 組合員の声一覧情報を取得する為、要求をサーバに送信する
      this.membersVoiceSearchVO = new MembersVoiceSearchModel();
      this.membersVoiceSearchVO.receiptNumFrom = this.inputVO.receiptNum;
      this.membersVoiceSearchVO.receiptNumTo = this.inputVO.receiptNum;
      this.membersVoiceSearchVO.orderGoodsFlg = orderGoodsFlg;
      this.getMembersVoiceSearchListService.execute(this.kymw0A00Model, this.membersVoiceSearchVO, () => {
        this.eventGetMembersVoiceListFirstCloseSuccess();
      });
    }
  }

  /**
   * 親画面に対して公開し、親画面からのパラメタを受け取るためのメソッド
   *
   * @param {*} param 受け渡すデータ
   * @memberof KYMW0A00Component
   */
  public setInterfaceParam(param: KYMW0A00InputModel): void {
    this.inputVO = param;
  }

  /**
   * メニューの作成
   *
   * @private
   * @memberof KYMW0A00Component
   */
  private initMenuBar(): void {
    if (this.inputVO == null || this.inputVO.formId === 'KYMW1002') {
      // 『トップ』画面から呼出しの場合
      if (this.kymw19funcPermission === '1') {
        this.kymw0A00Model.uploadMembersVoiceDataEnabled = false;
      }
    } else if (this.inputVO.formId === 'KYMW0900') {
      // 『商品企画メンテナンス』画面から呼出しの場合
      if (this.kymw09funcPermission === '1') {
        this.kymw0A00Model.uploadMembersVoiceDataEnabled = false;
      }
    } else if (this.inputVO.formId === 'KYMW1400') {
      // 『コマ割』画面から呼出しの場合
      if (this.kymw14funcPermission === '1') {
        this.kymw0A00Model.uploadMembersVoiceDataEnabled = false;
      }
    } else if (this.inputVO.formId === 'KYMW3001') {
      // 『1物N価商品企画メンテナンス』画面から呼出しの場合
      if (this.kymw30funcPermission === '1') {
        this.kymw0A00Model.uploadMembersVoiceDataEnabled = false;
      }
    } else if (this.inputVO.formId === 'KYMW3201') {
      // 『1物N価商品Ｗ掲載メンテナンス』画面から呼出しの場合
      if (this.kymw32funcPermission === '1') {
        this.kymw0A00Model.uploadMembersVoiceDataEnabled = false;
      }
    }

    // ［ファイル］メニューを作成
    const menuFile = new FMenu('#menuFile_kymw0A00', {
      header: 'ファイル',
      displayMemberPath: 'header',
      subItemsPath: 'items',
      selectedValuePath: 'menuID',
      dropDownCssClass: 'menubar-items',
      openOnHover: false,
      isAnimated: true,
      itemsSource: [
        { header: '組合員の声取込', menuID: 'mui_UploadMembersVoiceData', enabled: this.kymw0A00Model.uploadMembersVoiceDataEnabled },
        { header: '掲載組合員の声出力', menuID: 'mui_DownloadMembersVoiceData', enabled: true },
        ],
      command: this.getFormatMenuCommand(),
      // イベント設定
      itemClicked: () => {
        this.eventMenu_CLICKHandler(menuFile);
      }
    });

    this.fmenuService.menus = [ menuFile ];
  }

  private getFormatMenuCommand(): any {
    return {
      canExecuteCommand: (param) => {
        // 各項目の活性制御
        return (param.enabled === false) ? false : true;
      }
    };
  }

  /**
   * メニュー選択イベント処理
   *
   * @private
   * @param {Menu} menu
   * @memberof KYMW0A00Component
   */
  public eventMenu_CLICKHandler(menu: FMenu): void {
    switch (menu.selectedItem.menuID) {
      // 【ファイル】
      // 組合員の声取込
      case 'mui_UploadMembersVoiceData':
        this.uploadMembersVoice();
        break;

      // 掲載組合員の声出力
      case 'mui_DownloadMembersVoiceData':
        this.downloadMembersVoice();
        break;

      default:
        break;
    }
  }

  /**
   * 子画面からの値受け取り用
   *
   * @param {KYMW1900OutputModel} outputVO
   * @memberof KYMW0A00Component
   */
  public setKYMW1900Parameter(outputVO: KYMW1900OutputModel) {
    // 検索実行フラグを立てる
    this.searchFlg = true;

    // DataGridヘッダテキストの初期化を行う
    DataGridUtil.clearHeaderText(this.dtg_MembersVoiceList);

    // 検索前にDataGridをクリア
    this.dtg_MembersVoiceList.itemsSource = null;

    // 組合員の声検索からの戻り値を設定する
    this.membersVoiceSearchVO = new MembersVoiceSearchModel();
    this.membersVoiceSearchVO.receiptNumFrom = outputVO.receiptNumFrom;
    this.membersVoiceSearchVO.receiptNumTo = outputVO.receiptNumTo;
    this.membersVoiceSearchVO.classCode = outputVO.classCode;
    this.membersVoiceSearchVO.subject = outputVO.subject;
    this.membersVoiceSearchVO.inquiryContents = outputVO.inquiryContents;
    this.membersVoiceSearchVO.receiptDateFrom = outputVO.receiptDateFrom;
    this.membersVoiceSearchVO.receiptDateTo = outputVO.receiptDateTo;
    this.membersVoiceSearchVO.publishType = outputVO.publishType;
    this.membersVoiceSearchVO.coopCode = outputVO.coopCode;
    this.membersVoiceSearchVO.importDateFrom = outputVO.importDateFrom;
    this.membersVoiceSearchVO.importDateTo = outputVO.importDateTo;

    if (this.inputVO == null || this.inputVO.formId === 'KYMW1002') {           // TOP画面から
      this.membersVoiceSearchVO.orderGoodsFlg = '';
    } else if (this.inputVO.formId === 'KYMW0900') {                            // 商品企画メンテナンスから
      this.membersVoiceSearchVO.orderGoodsFlg = '01';
    } else if (this.inputVO.formId === 'KYMW3001') {                            // 1物N価商品企画メンテナンスから
      this.membersVoiceSearchVO.orderGoodsFlg = '02';
    } else if (this.inputVO.formId === 'KYMW3201') {                            // 1物N価商品Ｗ掲載メンテナンスから
      this.membersVoiceSearchVO.orderGoodsFlg = '03';
    } else if (this.inputVO.formId === 'KYMW1400') {                            // コマ割画面から
      // 注文商品区分取得
      this.membersVoiceSearchVO.orderGoodsFlg = this.inputVO.orderGoodsFlgKoma2;
      // フォームID取得
      this.membersVoiceSearchVO.formId = this.inputVO.formId;
      // 注文商品区分他レイアウト情報数分ループ得
      for (let i = Number(0); i < this.inputVO.orderGoodsFlgKoma.length; i++) {
        // いつでも注文商品、いつ注Ｗ掲載商品の場合
        if (this.inputVO.orderGoodsFlgKoma[i].OrderGoodsFlg === '02'
          || this.inputVO.orderGoodsFlgKoma[i].OrderGoodsFlg === '03') {
          // パラメータを設定
          this.membersVoiceSearchVO.orderNum6Digits = this.inputVO.NvalInputList[i].orderNum6Digits;      // 注文コード６桁
          this.membersVoiceSearchVO.receiptSOrderCode = this.inputVO.NvalInputList[i].receiptSOrderCode;  // 受付開始受注コード
          this.membersVoiceSearchVO.itemCode = this.inputVO.NvalInputList[i].itemCode;                    // アイテムコード
        }
      }
    }
    this.kYMW1900OutputVO = outputVO;

    // 組合員の声一覧情報を取得する為、要求をサーバに送信する
    this.getMembersVoiceSearchListService.execute(this.kymw0A00Model, this.membersVoiceSearchVO, () => {
      this.eventGetMembersVoiceListCloseSuccess();
    });
  }

  /**
   * 誌面掲載用項目情報活性、非活性
   *
   * @private
   * @param {boolean} flg
   * @memberof KYMW0A00Component
   */
  private inputComponentEnable(flg: boolean): void {
    this.plessEnabled(this.txti_CorrectMemberName, flg);
    this.plessEnabled(this.txti_CorrectAnonymous, flg);
    this.plessEnabled(this.rdbg_Coop, flg);
    this.plessEnabled(this.rdbg_Center, flg);
    this.plessEnabled(this.txti_CenterName, flg);
    this.plessEnabled(this.txta_InquiryContents, flg);
  }

  /**
   * 一覧の表示データ変更時イベント
   * @memberof KYMW0A00Component
   */
  public eventItemSourceChangedMembersVoiceListHandler() {
    if (!PlessViewUtilsSub.isEmptyArray(this.dtg_MembersVoiceList.itemsSource)) {
      if (this.inputVO
        && (this.inputVO.formId === 'KYMW0900' || this.inputVO.formId === 'KYMW3001' || this.inputVO.formId === 'KYMW3201')) {
        if (!PlessViewUtilsSub.isEmptyArray(this.kymw0A00Model.membersVoiceArray)) {
          // 一覧の検索結果を選択状態とする
          this.dtg_MembersVoiceList.select(0, -1);
        }
      } else {
        this.dtg_MembersVoiceList.select(-1, -1);
      }
    }
  }

  /**
   * 組合員の声取込ファイルを選択した時に呼び出されるメソッド。
   */
  public eventUploadMembersVoiceDataHandler(): void {
    this.uploadMembersVoiceDataService.execute(this.kymw0A00Model, this.fileRef[0], () => {
      this.eventUploadMembersVoiceDataCloseSuccess();
    });
  }

  /**
   * 検索ボタン押下時に呼び出されるメソッド。
   */
  public eventSearchHandler(): void {
    // 前回検索条件の設定
    const kYMW1900InputVO: KYMW1900InputModel = new KYMW1900InputModel();
    if (this.kYMW1900OutputVO !== null) {
      kYMW1900InputVO.receiptNumFrom = this.kYMW1900OutputVO.receiptNumFrom;
      kYMW1900InputVO.receiptNumTo = this.kYMW1900OutputVO.receiptNumTo;
      kYMW1900InputVO.classCode = this.kYMW1900OutputVO.classCode;
      kYMW1900InputVO.subject = this.kYMW1900OutputVO.subject;
      kYMW1900InputVO.inquiryContents = this.kYMW1900OutputVO.inquiryContents;
      kYMW1900InputVO.receiptDateFrom = this.kYMW1900OutputVO.receiptDateFrom;
      kYMW1900InputVO.receiptDateTo = this.kYMW1900OutputVO.receiptDateTo;
      kYMW1900InputVO.publishType = this.kYMW1900OutputVO.publishType;
      kYMW1900InputVO.coopCode = this.kYMW1900OutputVO.coopCode;
      kYMW1900InputVO.importDateFrom = this.kYMW1900OutputVO.importDateFrom;
      kYMW1900InputVO.importDateTo = this.kYMW1900OutputVO.importDateTo;
    }

    // 組合員の声検索画面(モーダル)を表示する。
    const componentRef = this.dialogService.openModal(KYMW1900Component);
    const instance = componentRef.componentInstance as KYMW1900Component;
    instance.parent = this;
    instance.setInterfaceParam(kYMW1900InputVO);
    instance.setKYMW1900Parameter = (outputVO: KYMW1900OutputModel) => {
      this.setKYMW1900Parameter(outputVO);
    };
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  /**
   * 更新ボタン押下時に呼び出されるメソッド。
   * @param event コールバック・イベントへの参照
   *
   */
  public eventUpdateHandler(): void {
    // 更新メイン処理実行
    this.updateMainProc();
  }

  /**
   * 選択ボタン押下時に呼び出されるメソッド。
   * @param event コールバック・イベントへの参照
   *
   */
  public eventSelectHandler(): void {
    // 「組合員の声一覧」で選択されていない場合はエラーとする
    if (PlessViewUtilsSub.isEmptyArray(this.dtg_MembersVoiceList.selectedRows)) {
      this.dialogService.openAlertGetMessage('E0103', ['組合員の声一覧']);
      return;
    }

    // 更新メイン処理実行
    this.updateMainProc();
  }

  /**
   * Ｐコードコンボボックスが変更されたときのイベント
   */
  public eventPcodeListChangeHandler(event: any): void {
    this.kymw0A00Model.guideGoodsName = this.kymw0A00Model.pcodeList[event.currentTarget.selectedIndex].GuideGoodsName;
    this.kymw0A00Model.guideStandardName = this.kymw0A00Model.pcodeList[event.currentTarget.selectedIndex].GuideStandardName;
    if (!PlessViewUtilsSub.isEmptyArray(this.kymw0A00Model.membersVoiceArray)) {
      // 呼び出し元画面と選択されたＰコードに紐付く受付番号を取得する為、要求をサーバに送信する
      const selectPublishVoiceVO: SelectPublishVoiceModel = new SelectPublishVoiceModel();
      selectPublishVoiceVO.selectPcode = this.kymw0A00Model.pcodeListSelectedValue;
      selectPublishVoiceVO.coopCode = this.inputVO.coopCode;
      selectPublishVoiceVO.orderCode = this.inputVO.orderCode;

      // Pコードリスト数分ループ
      for (let i = Number(0); i < this.inputVO.orderGoodsFlgKoma.length; i++) {
        // 画面で選択したPコードに紐づくキー項目値を取得する。
        if (this.inputVO.orderGoodsFlgKoma[i].PCode === selectPublishVoiceVO.selectPcode) {
          selectPublishVoiceVO.orderGoodsFlg = this.inputVO.orderGoodsFlgKoma[i].OrderGoodsFlg;  // 注文商品区分を設定
          if (this.inputVO.orderGoodsFlgKoma[i].OrderGoodsFlg === '02'
            || this.inputVO.orderGoodsFlgKoma[i].OrderGoodsFlg === '03') {
            selectPublishVoiceVO.orderNum6Digits = this.inputVO.NvalInputList[i].orderNum6Digits;     // 注文コード６桁
            selectPublishVoiceVO.receiptSOrderCode = this.inputVO.NvalInputList[i].receiptSOrderCode; // 受付開始受注コード
            selectPublishVoiceVO.itemCode = this.inputVO.NvalInputList[i].itemCode;                   // アイテムコード
          }
          break;
        }
      }

      this.getPublishVoiceDataService.execute(this.kymw0A00Model, selectPublishVoiceVO, () => {
        this.eventGetPublishVoiceDataCloseSuccess();
      });
    }
  }

  /**
   * 検索結果のデータグリッドのデータが押下されたときのイベント
   *
   * @private
   * @memberof KYMW0A00Component
   */
  public eventMembersVoiceListClickHandler(): void {
    // イベント発生元(データグリッド)のアイテムが選択状態かチェック
    if (!PlessViewUtilsSub.isEmptyArray(this.dtg_MembersVoiceList.selectedRows)) {

      // 入力フィールドをクリアする
      this.clearInputField();

      // 検索パラメータ
      const receiptNum: string = this.dtg_MembersVoiceList.selectedRows[0].dataItem.ReceiptNum;

      // 組合員の声詳細情報を取得する為、要求をサーバに送信する
      this.getMembersVoiceDataService.execute(this.kymw0A00Model, receiptNum, () => {
        this.eventGetMembersVoiceDataCloseSuccess();
      });
    }
  }

  /**
   * 「次へ」ボタンを押下した時に呼び出されるメソッド
   *
   * @memberof KYMW0A00Component
   */
  public eventNextHandler(): void {
    // 検索前にDataGridをクリア
    this.dtg_MembersVoiceList.itemsSource = null;
    // 保持しているVOからページカウンタを+1する(インクリメントで+1)
    this.membersVoiceSearchVO.pageNum++;
    // サーバにデータ取得を要求(Cairngormイベント発行)
    this.getPageData();
  }

  /**
   * 「前へ」ボタンを押下した時に呼び出されるメソッド
   *
   * @memberof KYMW0A00Component
   */
  public eventBackHandler(): void {
    // 検索前にDataGridをクリア
    this.dtg_MembersVoiceList.itemsSource = null;
    // 保持しているVOからページカウンタを-1する(デクリメントで-1)
    this.membersVoiceSearchVO.pageNum--;
    // サーバにデータ取得を要求(Cairngormイベント発行)
    this.getPageData();
  }

  /**
   * 前回同一検索条件でのデータ取得を行うメソッド
   *
   * @private
   * @memberof KYMW0A00Component
   */
  private getPageData(): void {
    // サーバにデータ取得を要求(Cairngormイベント発行)
    if (!this.searchFlg && this.inputVO.formId === 'KYMW1400') {
      this.getMembersVoicePcodeListService.execute(this.kymw0A00Model, this.membersVoiceSearchVO, () => {
        this.eventGetMembersVoiceListCloseSuccess();
      });
    } else {
      // 組合員の声一覧情報を取得する為、要求をサーバに送信する
      this.getMembersVoiceSearchListService.execute(this.kymw0A00Model, this.membersVoiceSearchVO, () => {
        this.eventGetMembersVoiceListCloseSuccess();
      });
    }
  }

  /**
   * 組合員の声掲載検索処理成功時実行メソッド
   *
   * @private
   * @returns {void}
   * @memberof KYMW0A00Component
   */
  private eventGetPublishVoiceDataCloseSuccess(): void {

    // 選択したＰコードに紐付く受付番号
    const selectReceiptNum: string = this.kymw0A00Model.selectReceiptNum;

    // 表示中の組合員の声一覧情報から同一の受付番号を検索
    const len = this.kymw0A00Model.membersVoiceArray.length;
    for (let i = Number(0); i < len; i++) {
      if (selectReceiptNum === this.kymw0A00Model.membersVoiceArray[i].ReceiptNum) {
        // this.dtg_MembersVoiceList.select(1, -1);
        this.dtg_MembersVoiceList.select(i, -1);

        // 入力フィールドをクリアする
        this.clearInputField();

        // 組合員の声詳細情報を取得する為、要求をサーバに送信する
        this.getMembersVoiceDataService.execute(this.kymw0A00Model, this.kymw0A00Model.membersVoiceArray[i].ReceiptNum, () => {
          this.eventGetMembersVoiceDataCloseSuccess();
        });

        return;
      }
    }

    // 表示中の組合員の声一覧情報にて一致する受付番号が無い場合
    // 組合員の声一覧の選択状態をクリア
    this.dtg_MembersVoiceList.select(-1, -1);

    // 詳細フィールドをクリア
    this.clearDetailField();
    // 入力フィールドをクリア
    this.clearInputField();
  }

  /**
   * 組合員の声一覧初期検索処理成功時実行メソッド
   */
  private eventGetMembersVoiceListFirstCloseSuccess(): void {

    // 組合員の声一覧検索処理成功時実行メソッドの実行
    this.eventGetMembersVoiceListCloseSuccess();

    // 検索結果が存在する場合は組合員の声詳細情報を検索
    if (!PlessViewUtilsSub.isEmptyArray(this.kymw0A00Model.membersVoiceArray)) {
      // 『商品企画メンテナンス』画面から呼出しの場合
      // 『1物N価商品企画メンテナンス』画面から呼出しの場合
      // 『1物N価商品Ｗ掲載メンテナンス』画面から呼出しの場合
      if (this.inputVO.formId === 'KYMW0900' || this.inputVO.formId === 'KYMW3001' || this.inputVO.formId === 'KYMW3201') {
        // 一覧の検索結果を選択状態とする
        // this.dtg_MembersVoiceList.selection = new CellRange(1, 1, 1, 1);
        this.dtg_MembersVoiceList.select(0, -1);

        // 入力フィールドをクリアする
        this.clearInputField();
        // 組合員の声詳細情報を取得する為、要求をサーバに送信する
        this.getMembersVoiceDataService.execute(this.kymw0A00Model, this.kymw0A00Model.membersVoiceArray[0].ReceiptNum, () => {
          this.eventGetMembersVoiceDataCloseSuccess();
        });
        // 項番2231 END 障害管理NO.U01140対応

        // 『コマ割』画面から呼出しの場合
      } else if (this.inputVO.formId === 'KYMW1400') {
        // １件目のＰコードに紐付く受付番号を取得する為、要求をサーバに送信する
        const selectPublishVoiceVO: SelectPublishVoiceModel = new SelectPublishVoiceModel();

        if (!PlessViewUtilsSub.isEmptyArray(this.inputVO.pcodeList)) {
          // 組合員の声選択画面、初期表示用にpcodeListの中で最小値のPコードを取得する。
          let wkPcode: string = this.inputVO.pcodeList[0];
          for (let i = 1; i < this.inputVO.pcodeList.length; i++) {
            if (wkPcode > this.inputVO.pcodeList[i]) {
              wkPcode = this.inputVO.pcodeList[i];
            }
          }
          selectPublishVoiceVO.selectPcode = wkPcode;
        }
        selectPublishVoiceVO.coopCode = this.inputVO.coopCode;
        selectPublishVoiceVO.orderCode = this.inputVO.orderCode;

        // Pコードリスト数分ループ
        for (let j = Number(0); j < this.inputVO.orderGoodsFlgKoma.length; j++) {
          // 画面で選択したPコードに紐づくキー項目値を取得する。
          if (this.inputVO.orderGoodsFlgKoma[j].PCode === selectPublishVoiceVO.selectPcode) {
            // パラメータを設定
            selectPublishVoiceVO.orderGoodsFlg = this.inputVO.orderGoodsFlgKoma[j].OrderGoodsFlg;     // 注文商品区分
            // いつでも注文商品、いつ注Ｗ掲載商品の場合
            if (this.inputVO.orderGoodsFlgKoma[j].OrderGoodsFlg === '02'
              || this.inputVO.orderGoodsFlgKoma[j].OrderGoodsFlg === '03') {
              selectPublishVoiceVO.orderNum6Digits = this.inputVO.NvalInputList[j].orderNum6Digits;     // 注文コード６桁
              selectPublishVoiceVO.receiptSOrderCode = this.inputVO.NvalInputList[j].receiptSOrderCode; // 受付開始受注コード
              selectPublishVoiceVO.itemCode = this.inputVO.NvalInputList[j].itemCode;                   // アイテムコード
            }
            break;
          }
        }

        this.getPublishVoiceDataService.execute(this.kymw0A00Model, selectPublishVoiceVO, () => {
          this.eventGetPublishVoiceDataCloseSuccess();
        });
      }
    } else {
      if (this._initFlag === true) {
        this._initFlag = false;
        this._initFlagGetMembersVoiceData = false;
        this._initFlagCheckNgWords = false;
        this.cmb_PcodeList.nativeElement.focus();
      }
    }
  }

  /**
   * 組合員の声一覧検索処理成功時実行メソッド
   */
  private eventGetMembersVoiceListCloseSuccess(): void {
    // 「前へ」ボタンの活性・非活性の判定
    this.btnBackEnabled = (this.kymw0A00Model.startDispNum > 1);

    // 「次へ」ボタンの活性・非活性の判定
    this.btnNextEnabled = (this.kymw0A00Model.endDispNum < this.kymw0A00Model.totalNum);
  }

  /**
   * 更新メイン処理
   * @param checkDiv チェック区分（true:チェック→更新、false:更新のみ）
   *
   */
  private updateMainProc(checkDiv = true): void {

    if (this.inputVO == null || this.inputVO.formId === 'KYMW1002') {
      // 『トップ』画面から呼出しの場合

      if (checkDiv) {
        // 入力チェック
        this.checkInputData();
        return;
      }

      // 「誌面掲載用項目」入力内容の更新処理の要求をサーバに送信する
      const membersVoiceInputDataVO: MembersVoiceInputDataModel = new MembersVoiceInputDataModel();
      membersVoiceInputDataVO.receiptNum = this.kymw0A00Model.receiptNum;
      membersVoiceInputDataVO.correctMemberName = this.kymw0A00Model.correctMemberName;
      membersVoiceInputDataVO.correctAnonymous = this.kymw0A00Model.correctAnonymous;
      membersVoiceInputDataVO.centerCoopDiv = this.kymw0A00Model.correctCenterCoopDiv;
      membersVoiceInputDataVO.centerName = this.kymw0A00Model.correctCenterName;
      membersVoiceInputDataVO.correctInquiryContents = this.kymw0A00Model.correctInquiryContents;

      this.updateMembersVoiceDataService.execute(this.kymw0A00Model, membersVoiceInputDataVO, () => {
        this.eventUpdateUpdateMembersVoiceDataCloseSuccess();
      });

    } else {
      // 『商品企画メンテナンス』、『1物N価商品企画メンテナンス』、『コマ割』画面から呼出しの場合

      // view項目の変更チェック
      if (this.kymw0A00Model.correctMemberName !== this.kymw0A00Model.defaultMemberName
        || this.kymw0A00Model.correctAnonymous !== this.kymw0A00Model.defaultAnonymous
        || this.kymw0A00Model.correctCenterCoopDiv !== this.kymw0A00Model.defaultCenterCoopDiv
        || this.kymw0A00Model.correctCenterName !== this.kymw0A00Model.defaultCenterName
        || this.kymw0A00Model.correctInquiryContents !== this.kymw0A00Model.defaultInquiryContents) {
        if (checkDiv) {
          // 入力チェック
          this.checkInputData();
          return;
        }

        // 「受付番号」を元に、既存データのチェックする為、要求をサーバに送信する
        const publishVoiceDataVO: PublishVoiceDataModel = new PublishVoiceDataModel();
        publishVoiceDataVO.receiptNum = this.kymw0A00Model.receiptNum;
        publishVoiceDataVO.coopCode = this.inputVO.coopCode;
        publishVoiceDataVO.orderCode = this.inputVO.orderCode;
        publishVoiceDataVO.pcode = this.kymw0A00Model.pcodeListSelectedValue;

        if (this.inputVO.formId === 'KYMW0900') {
          publishVoiceDataVO.orderGoodsFlg = '01';
        } else if (this.inputVO.formId === 'KYMW3001') {
          publishVoiceDataVO.orderGoodsFlg = '02';
        } else if (this.inputVO.formId === 'KYMW3201') {
          publishVoiceDataVO.orderGoodsFlg = '03';
        }

        // フォームIDがコマ割
        if (this.inputVO.formId === 'KYMW1400') {
          // Pコードリスト数分ループ
          for (let k = Number(0); k < this.inputVO.orderGoodsFlgKoma.length; k++) {
            // 画面で選択したPコードに紐づくキー項目値を取得する。
            if (this.inputVO.orderGoodsFlgKoma[k].PCode === publishVoiceDataVO.pcode) {
              // パラーメータを設定
              this.inputVO.orderGoodsFlg = this.inputVO.orderGoodsFlgKoma[k].OrderGoodsFlg;             // 注文商品区分
              publishVoiceDataVO.orderGoodsFlg = this.inputVO.orderGoodsFlgKoma[k].OrderGoodsFlg;       // 注文商品区分
              // いつでも注文商品、いつ注Ｗ掲載商品の場合
              if (this.inputVO.orderGoodsFlgKoma[k].OrderGoodsFlg === '02'
                || this.inputVO.orderGoodsFlgKoma[k].OrderGoodsFlg === '03') {
                publishVoiceDataVO.orderNum6Digits = this.inputVO.NvalInputList[k].orderNum6Digits;     // 注文コード６桁
                publishVoiceDataVO.receiptSOrderCode = this.inputVO.NvalInputList[k].receiptSOrderCode; // 受付開始受注コード
                publishVoiceDataVO.itemCode = this.inputVO.NvalInputList[k].itemCode;                   // アイテムコード
              }
              break;
            }
          }
        }

        this.getPublishVoiceHistory0A.execute(this.kymw0A00Model, publishVoiceDataVO, () => {
          this.updateMembersVoiceData2();
        });

      } else {
        // 更新確認メッセージを表示して、処理継続を確認す
        this.dialogService.openAlertGetMessage('Q0108', ['組合員の声', this.kymw0A00Model.ngWord], (closeDetail) => {
          // 誌面掲載用項目」入力内容の更新後の処理を実行する
          if (closeDetail === PlessAlert.Yes) {
            // 項番2231 START 障害管理NO.U01676対応
            if (this.inputVO.formId === 'KYMW1400') {
              // Pコードリスト数分ループ
              for (let k = Number(0); k < this.inputVO.orderGoodsFlgKoma.length; k++) {
                // 画面で選択したPコードに紐づくキー項目値を取得する。
                if (this.inputVO.orderGoodsFlgKoma[k].PCode === this.kymw0A00Model.pcodeListSelectedValue) {
                  // パラーメータを設定
                  this.inputVO.orderGoodsFlg = this.inputVO.orderGoodsFlgKoma[k].OrderGoodsFlg;
                }
              }
            }
            this.eventSelectUpdateMembersVoiceDataCloseSuccess();
          }
        });
      }
    }
  }

  private updateMembersVoiceData2(): void {
    // 「誌面掲載用項目」入力内容の更新処理の要求をサーバに送信する
    const membersVoiceInputDataVO: MembersVoiceInputDataModel = new MembersVoiceInputDataModel();
    membersVoiceInputDataVO.receiptNum = this.kymw0A00Model.receiptNum;
    membersVoiceInputDataVO.correctMemberName = this.kymw0A00Model.correctMemberName;
    membersVoiceInputDataVO.correctAnonymous = this.kymw0A00Model.correctAnonymous;
    membersVoiceInputDataVO.centerCoopDiv = this.kymw0A00Model.correctCenterCoopDiv;
    membersVoiceInputDataVO.centerName = this.kymw0A00Model.correctCenterName;
    membersVoiceInputDataVO.correctInquiryContents = this.kymw0A00Model.correctInquiryContents;

    this.updateMembersVoiceDataService.execute(this.kymw0A00Model, membersVoiceInputDataVO, () => {
      this.eventSelectUpdateMembersVoiceDataCloseSuccess();
    });
  }

  private updateMerbersVoiceData(): void {
    const membersVoiceInputDataVO: MembersVoiceInputDataModel = new MembersVoiceInputDataModel();
    membersVoiceInputDataVO.receiptNum = this.kymw0A00Model.receiptNum;
    membersVoiceInputDataVO.correctMemberName = this.kymw0A00Model.correctMemberName;
    membersVoiceInputDataVO.correctAnonymous = this.kymw0A00Model.correctAnonymous;
    membersVoiceInputDataVO.centerCoopDiv = this.kymw0A00Model.correctCenterCoopDiv;
    membersVoiceInputDataVO.centerName = this.kymw0A00Model.correctCenterName;
    membersVoiceInputDataVO.correctInquiryContents = this.kymw0A00Model.correctInquiryContents;

    this.updateMembersVoiceDataService.execute(this.kymw0A00Model, membersVoiceInputDataVO, () => {
      this.eventGetPublishVoiceHistoryCloseSuccess();
    });
  }

  /**
   * view入力項目のチェック処理
   * @param status 処理ステータス（true:初期処理、false:再帰処理）
   */
  private checkInputData(status = true): void {
    if (status) {
      // 初期チェック時

      // 「匿名希望者」が未入力の場合はエラーとする
      if (PlessViewUtilsSub.isEmpty(this.kymw0A00Model.correctAnonymous)) {
        this.dialogService.openAlertGetMessage('W0001', ['匿名希望者']);
        return;
      }

      // 「問合せ内容」が未入力の場合はエラーとする
      if (PlessViewUtilsSub.isEmpty(this.kymw0A00Model.correctInquiryContents)) {
        this.dialogService.openAlertGetMessage('W0001', ['問合せ内容']);
        return;
      }

      this.checkNgWords0AService.execute(this.kymw0A00Model, this.kymw0A00Model.correctInquiryContents, () => {
        this.eventUpdateCheckNgWordsCloseSuccess();
      });

      return;
    }

    // 「使用名称（センター名）」が選択され、「センター名」が未入力の場合はエラーとする
    if (this.kymw0A00Model.correctCenterCoopDiv === '2'
      && PlessViewUtilsSub.isEmpty(this.kymw0A00Model.correctCenterName)) {
      this.dialogService.openAlertGetMessage('E0106', ['使用名称（センター名）', 'センター名']);
      return;
    }

    // 更新確認メッセージを表示して、処理継続を確認す
    this.dialogService.openAlertGetMessage('Q0108', ['組合員の声'], (closeDetail) => {
      if (closeDetail === PlessAlert.Yes) {
        this.updateMainProc(false);
      }
    });
  }

  /**
   * 問合せ内容フォーカスアウト時ＮＧワードチェック処理成功時実行メソッド
   */
  private eventFocusOutCheckNgWordsCloseSuccess(): void {

    // ＮＧワードチェック結果を判定
    if (!PlessViewUtilsSub.isEmpty(this.kymw0A00Model.ngWord)) {
      this.dialogService.openAlertGetMessage('I0105', ['問合せ内容', this.kymw0A00Model.ngWord]);
    }
  }

  /**
   * 更新時ＮＧワードチェック処理成功時実行メソッド
   */
  private eventUpdateCheckNgWordsCloseSuccess(): void {

    // ＮＧワードチェック結果を判定
    if (PlessViewUtilsSub.isEmpty(this.kymw0A00Model.ngWord)) {
      // view入力項目のチェック処理の再帰呼出し
      this.checkInputData(false);
    } else {
      this.dialogService.openAlertGetMessage('Q0129', ['問合せ内容', this.kymw0A00Model.ngWord], (closeDetail) => {
        if (closeDetail === PlessAlert.Yes) {
          this.checkInputData(false);
        }
      });
    }
  }

  /**
   * 組合員の声管理更新処理（更新）成功時実行メソッド
   */
  private eventUpdateUpdateMembersVoiceDataCloseSuccess(): void {
    // 検索前にDataGridをクリア
    this.dtg_MembersVoiceList.itemsSource = null;

    // 詳細フィールドをクリアする
    this.clearDetailField();

    // 入力フィールドをクリアする
    this.clearInputField();

    // 更新ボタンを非活性にする
    this.plessEnabled(this.btn_Update, false);

    // 入力フィールドを非活性にする
    this.enabledInputField(false);

    this.inputComponentEnable(false);

    // 組合員の声一覧情報を取得する為、要求をサーバに送信する
    this.getMembersVoiceSearchListService.execute(this.kymw0A00Model, this.membersVoiceSearchVO, () => {
      this.eventGetMembersVoiceListCloseSuccess();
    });
  }

  /**
   * 組合員の声管理更新処理（更新）成功時実行メソッド
   *
   */
  private eventSelectUpdateMembersVoiceDataCloseSuccess(): void {
    if (this.inputVO.formId === 'KYMW1400' || !PlessViewUtilsSub.isEmpty(this.inputVO.coopCode)) {
      // 『コマ割』画面から呼出しの場合、または呼出し元画面からの受渡情報（生協コード）が指定されている場合

      // 「受付番号」を元に、既存データのチェックする為、要求をサーバに送信する
      const publishVoiceDataVO: PublishVoiceDataModel = new PublishVoiceDataModel();
      publishVoiceDataVO.receiptNum = this.kymw0A00Model.receiptNum;
      publishVoiceDataVO.coopCode = this.inputVO.coopCode;
      publishVoiceDataVO.orderCode = this.inputVO.orderCode;
      publishVoiceDataVO.pcode = this.kymw0A00Model.pcodeListSelectedValue;
      publishVoiceDataVO.orderGoodsFlg = this.inputVO.orderGoodsFlg;

      // いつでも注文商品、いつ注Ｗ掲載商品の場合
      if (publishVoiceDataVO.orderGoodsFlg === '02' || publishVoiceDataVO.orderGoodsFlg === '03') {
        // Pコードリスト数分ループ
        for (let i = Number(0); i < this.inputVO.pcodeList.length; i++) {
          // 画面で選択したPコードに紐づくキー項目値を取得する。
          if (this.inputVO.pcodeList[i] === publishVoiceDataVO.pcode) {
            publishVoiceDataVO.orderNum6Digits = this.inputVO.NvalInputList[i].orderNum6Digits;
            publishVoiceDataVO.receiptSOrderCode = this.inputVO.NvalInputList[i].receiptSOrderCode;
            publishVoiceDataVO.itemCode = this.inputVO.NvalInputList[i].itemCode;
            break;
          }
        }
      }

      this.getPublishVoiceHistory0A.execute(this.kymw0A00Model, publishVoiceDataVO, () => {
        this.updateMerbersVoiceData();
      });

    } else {
      // 呼出し元画面からの受渡情報（生協コード）が指定されていない場合
      const kYMW0A00OutputVO: KYMW0A00OutputModel = new KYMW0A00OutputModel();
      kYMW0A00OutputVO.receiptNum = this.kymw0A00Model.receiptNum;
      kYMW0A00OutputVO.inquiryContents = this.kymw0A00Model.correctInquiryContents;
      this.setKYMW0A00Parameter(kYMW0A00OutputVO);

      // 組合員の声選択を終了する
      this.closeFunction();
    }
  }

  /**
   * 組合員の声掲載既存データチェック処理成功時実行メソッド
   *
   */
  public eventGetPublishVoiceHistoryCloseSuccess(): void {
    // 変数定義
    let kYMW0A00OutputVO: KYMW0A00OutputModel;

    if (this.kymw0A00Model.publishVoiceExistFlg === '1') {
      // 「組合員の声掲載」に既存データありの場合はエラーとする
      // ※組合員の声は、同一内容を各生協で１回のみ掲載可能とする。
      this.dialogService.openAlertGetMessage('E0164', ['他で選択済み', '選択']);
      return;
    } else {
      // 「組合員の声掲載」に既存データなしの場合

      if (this.inputVO.formId === 'KYMW0900' || this.inputVO.formId === 'KYMW3001' || this.inputVO.formId === 'KYMW3201') {
        // 『商品企画メンテナンス』画面から呼出しの場合
        // 『1物M価商品企画メンテナンス』画面から呼出しの場合
        // 『1物M価商品Ｗ掲載メンテナンス』画面から呼出しの場合

        // KYMW0A00OutputVOを生成し、呼出元に返す
        kYMW0A00OutputVO = new KYMW0A00OutputModel();
        kYMW0A00OutputVO.receiptNum = this.kymw0A00Model.receiptNum;
        kYMW0A00OutputVO.inquiryContents = this.kymw0A00Model.correctInquiryContents;
        this.setKYMW0A00Parameter(kYMW0A00OutputVO);

        // 組合員の声選択を終了する
        this.closeFunction();

      } else if (this.inputVO.formId === 'KYMW1400') {
        // 『コマ割』画面から呼出しの場合

        // 組合員の声掲載の登録処理をする為、要求をサーバに送信する
        const publishVoiceDataVO: PublishVoiceDataModel = new PublishVoiceDataModel();
        publishVoiceDataVO.receiptNum = this.kymw0A00Model.receiptNum;
        publishVoiceDataVO.coopCode = this.inputVO.coopCode;
        publishVoiceDataVO.orderCode = this.inputVO.orderCode;
        publishVoiceDataVO.pcode = this.kymw0A00Model.pcodeListSelectedValue;

        // Pコードリスト数分ループ
        for (let k = Number(0); k < this.inputVO.orderGoodsFlgKoma.length; k++) {
          // 画面で選択したPコードに紐づくキー項目値を取得する。
          if (this.inputVO.orderGoodsFlgKoma[k].PCode === publishVoiceDataVO.pcode) {
            // パラメータを設定
            publishVoiceDataVO.orderGoodsFlg = this.inputVO.orderGoodsFlgKoma[k].OrderGoodsFlg;    // 注文商品区分
            // いつでも注文商品、いつ注Ｗ掲載商品の場合
            if (this.inputVO.orderGoodsFlgKoma[k].OrderGoodsFlg === '02'
              || this.inputVO.orderGoodsFlgKoma[k].OrderGoodsFlg === '03') {
              publishVoiceDataVO.orderNum6Digits = this.inputVO.NvalInputList[k].orderNum6Digits;     // 注文コード６桁
              publishVoiceDataVO.receiptSOrderCode = this.inputVO.NvalInputList[k].receiptSOrderCode; // 受付開始受注コード
              publishVoiceDataVO.itemCode = this.inputVO.NvalInputList[k].itemCode;                   // アイテムコード
            }
            break;
          }
        }

        this.registPublishVoiceDataService.execute(this.kymw0A00Model, publishVoiceDataVO, () => {
          // 組合員の声選択を終了する
          this.closeFunction();
        });
      }
    }
  }

  /**
   * 組合員の声管理データ取得処理成功時実行メソッド
   */
  private eventGetMembersVoiceDataCloseSuccess(): void {
    // 「更新ボタン」が表示状態の場合は活性化する
    if (this.kymw0A00Model.btnUpdateVisible === STYLE_VISIBILITY.SHOW) {
      this.plessEnabled(this.btn_Update, true);

      this.enabledInputField(true);
      this.inputComponentEnable(true);
    }

    // NG-WORD CHECK 処理を行う
    this.checkNgWords0AService.execute(this.kymw0A00Model, this.kymw0A00Model.correctInquiryContents, () => {
      this.eventFocusOutCheckNgWordsCloseSuccess();
    });
  }

  /**
   * 詳細フィールドクリアメソッド
   */
  private clearDetailField(): void {
    // 詳細フィールドをクリアする
    this.kymw0A00Model.receiptNum = '';
    this.kymw0A00Model.coopName = '';
    this.kymw0A00Model.pcode = '';
    this.kymw0A00Model.memberName = '';
    this.kymw0A00Model.anonymous = '';
    this.kymw0A00Model.className = '';
    this.kymw0A00Model.subject = '';
    this.kymw0A00Model.inquiryContents = '';
    this.kymw0A00Model.receiptDate = '';
  }

  /**
   * 入力フィールドクリアメソッド
   */
  private clearInputField(): void {
    // 入力フィールドをクリアする
    this.kymw0A00Model.correctMemberName = '';
    this.kymw0A00Model.correctAnonymous = '';
    this.kymw0A00Model.correctCenterCoopDiv = '1';
    this.kymw0A00Model.correctCenterName = '';
    this.kymw0A00Model.correctInquiryContents = '';
    // 初期値保存用もクリア
    this.kymw0A00Model.defaultMemberName = '';
    this.kymw0A00Model.defaultAnonymous = '';
    this.kymw0A00Model.defaultCenterCoopDiv = '1';
    this.kymw0A00Model.defaultCenterName = '';
    this.kymw0A00Model.defaultInquiryContents = '';
  }

  /**
   * 入力フィールド活性制御メソッド
   */
  private enabledInputField(enabledFlg: boolean): void {
    this.plessEnabled(this.txti_CorrectMemberName, enabledFlg);
    this.plessEnabled(this.txti_CorrectAnonymous, enabledFlg);
    this.plessEnabled(this.rdbg_Coop, enabledFlg);
    this.plessEnabled(this.rdbg_Center, enabledFlg);
    this.plessEnabled(this.txti_CenterName, enabledFlg);
    this.plessEnabled(this.txta_InquiryContents, enabledFlg);
  }

  /**
   * 組合員の声取込ファイルアップロード処理成功時実行メソッド
   */
  private eventUploadMembersVoiceDataCloseSuccess(): void {
    // 処理ログ登録画面の呼び出し
    const componentRef = this.dialogService.openModal(KYMW0D00Component);
    const instance = componentRef.componentInstance as KYMW0D00Component;
    instance.parent = this;
    instance.setInterfaceParam(this.kymw0A00Model.kYMW0D00InputVO);
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  /**
   * データグリッドヘッダークリックした時に呼び出されるメソッド。
   *
   * @param {MouseEvent} e DataGrid上で発生したイベントオブジェクト(HeaderReleaseイベントをフックして引数としてください)
   * @param {FlexGrid} grid 対象データグリッド
   * @returns {void}
   * @memberof KYMW0A00Component
   */
  public eventMembersVoiceListHeaderReleaseHandler(e: MouseEvent, grid: FlexGrid): void {
    // 後続のデフォルトイベントをキャンセル
    event.preventDefault();

    if (grid.itemsSource == null) {
      return;
    }

    if (DataGridUtil.isSortable(e, grid)) {
      // クリックされたデータグリッドの列から、DBの物理項目を取得
      this.kymw0A00Model.sortKey = this.selectedListField.get(this.dtg_MembersVoiceList.columns[grid.hitTest(e).col].binding);
      // 取得できなかったら何もしない
      if (!this.kymw0A00Model.sortKey) {
        return;
      }
      // データグリッドのヘッダテキストを描画し、ASCとDESCをVOに設定
      this.kymw0A00Model.orderKey = DataGridUtil.switchHeaderText(e, grid);
      this.membersVoiceSearchVO.sortOrder = this.kymw0A00Model.orderKey;
      this.membersVoiceSearchVO.sortItem = this.kymw0A00Model.sortKey;
      // ページカウンタの初期化
      this.kymw0A00Model.pageNo = 1;
      this.membersVoiceSearchVO.pageNum = 1;
      // １ページ目を検索
      this.getPageData();
      return;
    } else {
      if (!PlessViewUtilsSub.isEmptyArray(grid.itemsSource)) {
        // ヘッダー内部がクリックされた場合
        if (grid.hitTest(e).cellType !== CellType.ColumnHeader
          || grid.hitTest(e).edgeLeft || grid.hitTest(e).edgeRight) {
          this.eventMembersVoiceListClickHandler();
        }
      }
    }
  }

  public nextFocus(event: any): void {
    // 次項目移動の場合（Shiftキー押下時は逆移動の為、制御しない）
    if (event.keyCode === 9 && !event.shiftKey) {
      // event.preventDefault();
      if (this.kymw0A00Model.lblPcodeListLblVisible === 'hidden') {
        // Pコードコンボボックスが表示されていない場合、「検索」へフォーカス移動
        this.btn_Search.nativeElement.focus();
      } else {
        // Pコードコンボボックスが表示されている場合、Pコードコンボボックスへフォーカス移動
        this.cmb_PcodeList.nativeElement.focus();
      }
    }
  }

  /**
   * 組合員の声取込
   *
   * @memberof KYMW0A00Component
   */
  public uploadMembersVoice(): void {
    this.fileUploadService.upload((selectedFiles: File[]) => {
      // 選択したファイルの拡張子チェック
      const extension = PlessViewUtilsSub.getExtension(selectedFiles[0].name);
      if (extension !== 'csv') {
        this.dialogService.openAlertGetMessage('E0220');
        return;
      }
      this.fileRef = selectedFiles;
      this.eventUploadMembersVoiceDataHandler();
    }, [FileAccept.CSV], false);
  }

  /**
   * 掲載組合員の声出力
   *
   * @memberof KYMW0A00Component
   */
  public downloadMembersVoice(): void {
    // 受渡項目の設定
    const kYMW1901InputVO: KYMW1901InputModel = new KYMW1901InputModel();
    kYMW1901InputVO.formId = 'KYMW0A00';

    // 組合員の声検索画面(モーダル)を表示する。
    const componentRef = this.dialogService.openModal(KYMW1901Component);
    const instance = componentRef.componentInstance as KYMW1901Component;
    instance.parent = this;
    instance.setInterfaceParam(kYMW1901InputVO);
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  /**
   * 組合員の声取込ボタン押下時のイベントハンドラ
   *
   * @memberof KYMW0A00Component
   */
  public eventUploadMembersVoiceDataButton(): void {
    this.uploadMembersVoice();
  }

  /**
   * 掲載組合員の声出力ボタン押下時のイベントハンドラ
   *
   * @memberof KYMW0A00Component
   */
  public eventDownloadMembersVoiceDataButton(): void {
    this.downloadMembersVoice();
  }
}
